import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const FEATURES = [
  { emoji: '🏘️', title: 'Local Groups', desc: 'Find or start hobby groups in your neighbourhood — from chess clubs to cooking circles.' },
  { emoji: '🎪', title: 'Events & Meetups', desc: 'Host events, run webinars, or join local meetups — all within your community.' },
  { emoji: '🛍️', title: 'Community Shop', desc: 'Buy & sell within your group — home-baked cakes, handmade crafts, lesson kits.' },
  { emoji: '🏆', title: 'Expert Groups', desc: 'Connect with coaches and experts for badminton, piano, chess, robotics and more.' },
  { emoji: '📣', title: 'Campaigns', desc: 'Run awareness drives, neighbourhood initiatives, and fundraising inside your community.' },
  { emoji: '💬', title: 'Group Chat', desc: 'Real-time chat with your community members — private or group-wide.' },
];

const COMMUNITIES = [
  { emoji: '🍲', label: 'Food', color: '#C05621', desc: 'Home chefs, bakers, tiffin services' },
  { emoji: '📚', label: 'Tutor', color: '#2563EB', desc: 'Tuition teachers, study groups' },
  { emoji: '🏅', label: 'Sports', color: '#059669', desc: 'Badminton, cricket, yoga, fitness' },
  { emoji: '🎨', label: 'Hobby Classes', color: '#7C3AED', desc: 'Art, music, dance, crafts' },
  { emoji: '🛍️', label: 'Shop at Home', color: '#DB2777', desc: 'Gifts, crafts, home goods' },
  { emoji: '🎪', label: 'Events', color: '#D97706', desc: 'Kitty parties, celebrations' },
  { emoji: '🕉️', label: 'Bhajan', color: '#92400E', desc: 'Spiritual gatherings, mandalis' },
  { emoji: '✈️', label: 'Travel', color: '#0891B2', desc: 'Trips, treks, getaways' },
];

const STEPS = [
  { n: '1', title: 'Create your group', desc: 'Pick a name, category, and who can join. Takes 30 seconds.' },
  { n: '2', title: 'Invite your people', desc: 'Share the link or invite by email — members join instantly.' },
  { n: '3', title: 'Build your community', desc: 'Chat, host events, run a shop. Everything in one place.' },
];


export default function LandingPage({ onAuth }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div style={{ fontFamily: "'Inter', system-ui, sans-serif", color: '#1C1917', background: '#FAFAF8', overflowX: 'hidden' }}>

      {/* ── Hero ── */}
      <section style={{ padding: '80px 20px 60px', textAlign: 'center', background: 'linear-gradient(180deg, rgba(192,86,33,0.06) 0%, transparent 100%)' }}>
        <div style={{ maxWidth: 760, margin: '0 auto' }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: '#FEF3EC', border: '1px solid #C05621', borderRadius: 20, padding: '6px 14px', fontSize: 13, fontWeight: 600, color: '#C05621', marginBottom: 24 }}>
            🇮🇳 India-first community platform
          </div>
          <h1 style={{ fontSize: 'clamp(32px, 7vw, 64px)', fontWeight: 900, lineHeight: 1.1, marginBottom: 20, letterSpacing: '-0.02em' }}>
            Your neighbourhood,<br/>
            <span style={{ background: 'linear-gradient(135deg,#C05621,#38785A)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>connected.</span>
          </h1>
          <p style={{ fontSize: 'clamp(16px, 2.5vw, 20px)', color: '#57534E', lineHeight: 1.6, marginBottom: 36, maxWidth: 580, margin: '0 auto 36px' }}>
            Ledxo Hub enables communities to gather, organise, trade, and grow — all in one place. Start a local group in 30 seconds.
          </p>
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
            <button onClick={() => onAuth('register')} style={{ padding: '14px 32px', borderRadius: 10, border: 'none', background: 'linear-gradient(135deg,#C05621,#9A4217)', cursor: 'pointer', fontWeight: 800, fontSize: 17, color: '#fff', fontFamily: 'inherit', boxShadow: '0 4px 16px rgba(192,86,33,0.4)', letterSpacing: '-0.01em' }}>
              Start your community →
            </button>
            <button onClick={() => onAuth('login')} style={{ padding: '14px 28px', borderRadius: 10, border: '2px solid #D4D0C8', background: '#fff', cursor: 'pointer', fontWeight: 700, fontSize: 17, color: '#1C1917', fontFamily: 'inherit' }}>
              Sign in
            </button>
          </div>
          <p style={{ marginTop: 16, fontSize: 13, color: '#A8A29E' }}>Free forever for community groups · No credit card needed</p>
        </div>

      </section>

      {/* ── Community types ── */}
      <section style={{ padding: '60px 20px', background: '#fff' }}>
        <div style={{ maxWidth: 1100, margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: 40 }}>
            <h2 style={{ fontSize: 'clamp(24px, 4vw, 36px)', fontWeight: 900, marginBottom: 10 }}>Every kind of community</h2>
            <p style={{ color: '#57534E', fontSize: 16 }}>From kitty parties to badminton clubs — Ledxo Hub has a home for it.</p>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 12 }}>
            {COMMUNITIES.map(c => (
              <button key={c.label} onClick={() => onAuth('register')}
                style={{ padding: '18px 16px', borderRadius: 12, border: '1.5px solid #E8E4DC', background: '#FAFAF8', cursor: 'pointer', textAlign: 'left', fontFamily: 'inherit', transition: 'all 0.15s' }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = c.color; e.currentTarget.style.background = '#fff'; e.currentTarget.style.boxShadow = `0 4px 16px ${c.color}22`; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = '#E8E4DC'; e.currentTarget.style.background = '#FAFAF8'; e.currentTarget.style.boxShadow = 'none'; }}>
                <div style={{ fontSize: 28, marginBottom: 8 }}>{c.emoji}</div>
                <div style={{ fontWeight: 700, fontSize: 15, color: '#1C1917', marginBottom: 4 }}>{c.label}</div>
                <div style={{ fontSize: 12, color: '#78716C', lineHeight: 1.4 }}>{c.desc}</div>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* ── Features ── */}
      <section style={{ padding: '60px 20px', background: '#F3F1EC' }}>
        <div style={{ maxWidth: 1100, margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: 40 }}>
            <h2 style={{ fontSize: 'clamp(24px, 4vw, 36px)', fontWeight: 900, marginBottom: 10 }}>Everything your community needs</h2>
            <p style={{ color: '#57534E', fontSize: 16 }}>One platform — groups, events, shop, experts, campaigns.</p>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 16 }}>
            {FEATURES.map(f => (
              <div key={f.title} style={{ padding: '24px', background: '#fff', borderRadius: 14, border: '1px solid #E8E4DC', boxShadow: '0 1px 4px rgba(0,0,0,0.04)' }}>
                <div style={{ fontSize: 32, marginBottom: 12 }}>{f.emoji}</div>
                <div style={{ fontWeight: 700, fontSize: 17, marginBottom: 6 }}>{f.title}</div>
                <div style={{ fontSize: 14, color: '#57534E', lineHeight: 1.6 }}>{f.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── How it works ── */}
      <section style={{ padding: '60px 20px', background: '#fff' }}>
        <div style={{ maxWidth: 800, margin: '0 auto', textAlign: 'center' }}>
          <h2 style={{ fontSize: 'clamp(24px, 4vw, 36px)', fontWeight: 900, marginBottom: 10 }}>Up and running in minutes</h2>
          <p style={{ color: '#57534E', fontSize: 16, marginBottom: 40 }}>No setup fees. No technical knowledge needed.</p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 20 }}>
            {STEPS.map((s, i) => (
              <div key={s.n} style={{ position: 'relative' }}>
                <div style={{ width: 44, height: 44, borderRadius: '50%', background: 'linear-gradient(135deg,#C05621,#9A4217)', color: '#fff', fontWeight: 900, fontSize: 20, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 14px' }}>{s.n}</div>
                {i < STEPS.length - 1 && (
                  <div style={{ position: 'absolute', top: 22, left: 'calc(50% + 22px)', right: 'calc(-50% + 22px)', height: 2, background: '#E8E4DC', display: 'none' }} className="step-connector" />
                )}
                <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 6 }}>{s.title}</div>
                <div style={{ fontSize: 14, color: '#57534E', lineHeight: 1.5 }}>{s.desc}</div>
              </div>
            ))}
          </div>
          <button onClick={() => onAuth('register')} style={{ marginTop: 40, padding: '14px 36px', borderRadius: 10, border: 'none', background: 'linear-gradient(135deg,#C05621,#9A4217)', cursor: 'pointer', fontWeight: 800, fontSize: 16, color: '#fff', fontFamily: 'inherit', boxShadow: '0 4px 16px rgba(192,86,33,0.35)' }}>
            Create your first group →
          </button>
        </div>
      </section>


      {/* ── CTA band ── */}
      <section style={{ padding: '70px 20px', background: 'linear-gradient(135deg,#C05621,#38785A)', textAlign: 'center' }}>
        <h2 style={{ fontSize: 'clamp(26px, 5vw, 44px)', fontWeight: 900, color: '#fff', marginBottom: 14, letterSpacing: '-0.02em' }}>
          Your community is waiting.
        </h2>
        <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: 17, marginBottom: 32 }}>
          Join the first communities on Ledxo Hub.
        </p>
        <button onClick={() => onAuth('register')} style={{ padding: '16px 40px', borderRadius: 10, border: '2px solid rgba(255,255,255,0.4)', background: '#fff', cursor: 'pointer', fontWeight: 800, fontSize: 18, color: '#C05621', fontFamily: 'inherit', boxShadow: '0 4px 20px rgba(0,0,0,0.2)' }}>
          Get started — it's free →
        </button>
      </section>

      {/* ── Footer ── */}
      <footer style={{ background: '#1C1917', color: '#A8A29E', padding: '40px 20px 24px' }}>
        <div style={{ maxWidth: 1100, margin: '0 auto' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: 24, marginBottom: 32 }}>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
                <svg width="28" height="28" viewBox="0 0 64 64" fill="none">
                  <rect width="64" height="64" rx="16" fill="url(#lp-foot-grad)"/>
                  <circle cx="32" cy="32" r="8.5" fill="white"/>
                  <circle cx="32" cy="11" r="5.2" fill="white" opacity="0.92"/>
                  <circle cx="50" cy="21.5" r="5.2" fill="white" opacity="0.92"/>
                  <circle cx="50" cy="42.5" r="5.2" fill="white" opacity="0.92"/>
                  <circle cx="32" cy="53" r="5.2" fill="white" opacity="0.92"/>
                  <circle cx="14" cy="42.5" r="5.2" fill="white" opacity="0.92"/>
                  <circle cx="14" cy="21.5" r="5.2" fill="white" opacity="0.92"/>
                  <defs>
                    <linearGradient id="lp-foot-grad" x1="0" y1="0" x2="64" y2="64" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#C05621"/><stop offset="1" stopColor="#38785A"/>
                    </linearGradient>
                  </defs>
                </svg>
                <div style={{ fontWeight: 900, fontSize: 18, color: '#fff' }}>Ledxo Hub</div>
              </div>
              <div style={{ fontSize: 13, lineHeight: 1.6 }}>India's hyper-local community platform — groups, food, events, and commerce, all in your neighbourhood.</div>
              <div style={{ marginTop: 8, fontSize: 12, color: '#78716C' }}>Powered by <span style={{ color: '#C05621', fontWeight: 600 }}>Ledxo</span></div>
              <div style={{ marginTop: 4, fontSize: 12 }}>A <a href="https://quantaiseed.com/" target="_blank" rel="noopener noreferrer" style={{ color: '#C05621', textDecoration: 'none', fontWeight: 600 }}>QuantaiSeed</a> product</div>
            </div>
            <div>
              <div style={{ color: '#fff', fontWeight: 700, fontSize: 12, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 12 }}>Platform</div>
              {[['Communities', '/'], ['Social Feed', '/social'], ['Events', '/events'], ['Find Folks', '/find-folks']].map(([l, to]) => (
                <div key={l} style={{ marginBottom: 8 }}><Link to={to} onClick={() => {}} style={{ color: '#A8A29E', textDecoration: 'none', fontSize: 14 }}>{l}</Link></div>
              ))}
            </div>
            <div>
              <div style={{ color: '#fff', fontWeight: 700, fontSize: 12, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 12 }}>Earn</div>
              {[['Sell on Ledxo Hub', '/seller'], ['Become an Expert', '/expert'], ['Post a Need', '/requests']].map(([l, to]) => (
                <div key={l} style={{ marginBottom: 8 }}><Link to={to} style={{ color: '#A8A29E', textDecoration: 'none', fontSize: 14 }}>{l}</Link></div>
              ))}
            </div>
            <div>
              <div style={{ color: '#fff', fontWeight: 700, fontSize: 12, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 12 }}>Company</div>
              <div style={{ marginBottom: 8 }}><a href="https://quantaiseed.com/" target="_blank" rel="noopener noreferrer" style={{ color: '#A8A29E', textDecoration: 'none', fontSize: 14 }}>QuantAISeed ↗</a></div>
              <div style={{ marginBottom: 8 }}><Link to="/privacy" style={{ color: '#A8A29E', textDecoration: 'none', fontSize: 14 }}>Privacy Policy</Link></div>
              <div style={{ marginBottom: 8 }}><a href="mailto:contact@quantaiseed.com" style={{ color: '#A8A29E', textDecoration: 'none', fontSize: 14 }}>Contact</a></div>
            </div>
          </div>
          <div style={{ borderTop: '1px solid #292524', paddingTop: 20, fontSize: 12, display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8 }}>
            <span>© 2026 <a href="https://quantaiseed.com/" target="_blank" rel="noopener noreferrer" style={{ color: '#78716C', textDecoration: 'none' }}>QuantaiSeed</a> &nbsp;·&nbsp; Ledxo Hub &nbsp;·&nbsp; hub.ledxo.com</span>
            <span>🇮🇳 Made in India</span>
          </div>
        </div>
      </footer>
    </div>
  );
}
